import { Grid, GridProps } from '@mui/material';
import { useField } from 'formik';

import { FormFieldProps } from '../index';
import { FormFieldWrapper } from '../shared/formFieldWrapper';
import { Select, SelectProps } from '../../../../atomic/input/select';
import { useAdditionalOnChange } from './hooks/useAdditionalOnChange';

export type FormListSelectProps = FormFieldProps &
  Omit<SelectProps, 'onChange' | 'helperText'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

export const FormListSelect = FormFieldWrapper<FormListSelectProps>(
  ({ additionalOnChange, ...props }) => {
    const [field, meta] = useField<string>({
      name: props.name
    });

    const onChange = useAdditionalOnChange(field.onChange, additionalOnChange);

    return (
      <Grid item xs={props.xs ?? 12} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
        <Select
          {...props}
          label={props.label}
          name={field.name}
          value={field.value}
          onChange={onChange}
          onBlur={field.onBlur}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.error}
          options={props.options}
          isMultiple={true}
        />
      </Grid>
    );
  },
  (props: FormListSelectProps) => (props.multiple ? [] : '')
);
